import React from 'react'
import BlogContext from '../context/BlogContext'
import { get } from 'aws-amplify/api'
import { useAuth0 } from '@auth0/auth0-react'
import { buildPathWithQuery } from '../utils/buildQueryString'

const BlogProvider = ({ children }) => {
  const { getIdTokenClaims } = useAuth0()
  const baseUrl = process.env.REACT_APP_API_BASE_URL

  const getBlogArticleList = async (params) => {
    try {
      const idToken = await getIdTokenClaims()

      const pathWithParams = buildPathWithQuery('/health/getBlogArticleList', params)

      const resp = get({
        apiName: baseUrl,
        path: pathWithParams,
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${idToken.__raw}`
          }
        }
      })
      const { body } = await resp.response
      const data = await body.json()
      return data.data
    } catch (error) {
      throw new Error(error)
    }
  }

  const getCategoryArticleList = async (params) => {
    try {
      const idToken = await getIdTokenClaims()

      const pathWithParams = buildPathWithQuery('/health/getCategoryArticleList', params)

      const resp = get({
        apiName: baseUrl,
        path: pathWithParams,
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${idToken.__raw}`
          }
        }
      })
      const { body } = await resp.response
      const data = await body.json()
      return data.data
    } catch (error) {
      throw new Error(error)
    }
  }

  return (
    <BlogContext.Provider
      value={{
        getCategoryArticleList,
        getBlogArticleList
      }}
    >
      {children}
    </BlogContext.Provider>
  )
}

export default BlogProvider
